<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({ name: "UiDatePicker" });
</script>
<template>
    <!-- * 时间选择器 -->
    <div class="ui-date-picker" ref="container" v-bind="binds.container">
        <!-- * 选择器主体 -->
        <input class="ui-form-control" type="text" v-bind="binds.main" @click="show" readonly />

        <!-- * 清空图标 -->
        <UiIcon class="ui-date-picker-icons ui-date-picker-clearable" name="error" @click="clear" />
        <!-- * 箭头图标 -->
        <UiIcon class="ui-date-picker-icons ui-date-picker-arrow" name="arrow" @click="show" />

        <!-- * 候选列表 -->
        <Transition v-on="ons.candidates">
            <div class="ui-form-candidates" ref="body" v-if="visible" v-bind="binds.body">
                <div class="ui-form-candidate-container">
                    <component ref="components" :is="analyzeComponent" @update="update" @change="change"></component>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script lang="ts" setup>
//* Vue
import { onBeforeUnmount } from "vue";
//* 组件引入
import UiIcon from "@various/components/icon";
//* 组件属性
import { UiDatePickerPropsOption, UiDatePickerEmits } from "./src/component";
import { useComposable } from "./src/composable";
//* 公共属性
import { node } from "@various/utils";

//* 组件属性注册
const define = defineProps(UiDatePickerPropsOption);
const emits = defineEmits(UiDatePickerEmits);

//* 组合函数
const { ons, vars, refs, nodes, binds, methods, analyzes } = useComposable(define, emits);
const { visible } = refs;
const { components, container, body } = nodes;
const { show, clear, update, change } = methods;
const { analyzeComponent } = analyzes;

//* 组件卸载时释放内存
onBeforeUnmount(() => {
    //* 将内容从视图容器中移除
    body.value && node.remove(document.body, body.value);
    //* 销毁观察者
    vars.observer?.disconnect();
});

//* 初始化组件配置
;
defineExpose({ clear, update, change });
</script>
